import { development } from "/src/config/development";
import { production } from "/src/config/production";

const APP_ENV = process.env.NODE_ENV || "development";

// Map staging to production config for now (they share the same config structure)
const envKey = APP_ENV === "production" || APP_ENV === "staging" ? "production" : "development";

const configs = {
  development,
  production,
};

export const config = configs[envKey];

export default config;
